import React from 'react';
import cn from 'classnames';
import { IBaseElementProps } from 'tbk-components/src/components/BasicElement';
import Button, { ILink } from 'tbk-components/src/components/Button';
import FeaturedProject, { IFeaturedProjectProps } from './FeaturedProject';
export interface IFeaturedProjectsProps extends IBaseElementProps {
	title?: string;
	tiles?: IFeaturedProjectProps[];
	cta?: ILink;
}

/**
 * Calian Featured Projects
 * @icon welcome-widgets-menus
 * @block
 */
const FeaturedProjects: React.FC<IFeaturedProjectsProps> = ({
	id,
	className,
	classNames = [],
	title,
	cta,
	tiles = [],
}) => {
	return (
		<div
			id={id}
			className={cn(
				className || [
					'calian-featured-projects',
					'px-3 py-12 position-relative theme-bg-radial-gradient-one text-white',
					...classNames,
				],
			)}
		>
			<div className="calian-featured-projects__container container px-0 w-100 mx-auto d-flex align-items-center flex-column gap-8">
				{title && (
					<h2 className="text-center text-white mb-0">{title}</h2>
				)}

				{tiles?.length > 0 && (
					<div className="calian-featured-projects__tiles w-100 h-auto rounded-5 overflow-hidden">
						{tiles.map((tile, index) => {
							return (
								<FeaturedProject
									key={index}
									{...tile}
								></FeaturedProject>
							);
						})}
					</div>
				)}

				{cta?.label && <Button {...cta} type="secondary" />}
			</div>
		</div>
	);
};

export default FeaturedProjects;
